import { default as React } from 'react';
import { useAutoSaveField } from '../../Components/AutosaveForm/AutosaveField';
import { useAutosaveForm } from '../../Components/AutosaveForm/AutosaveForm';
import { MaskedTextField } from '../../Components/MaskedTextField';
import { EditIcon } from '../../Components/Icons';
import { primaryBlue } from '../../Styles/Colours';
import { decimalNumberInputFilter } from '../../Shared/InputFilters';
import { AutosaveTextField } from '../../Components/AutosaveForm/AutosaveTextField';
import styles from './StandardPackSizeDisplay.module.css';
function EditButton(_a) {
    var onClick = _a.onClick;
    return (React.createElement("button", { onClick: onClick, className: styles.editButton, "data-test-id": 'button-edit-pack-size' },
        React.createElement(EditIcon, { color: primaryBlue, size: '16', noPadding: true }),
        React.createElement("span", { className: styles.text }, "Edit")));
}
export var StandardPackSizeDisplay = function (props) {
    var _a, _b, _c;
    var medicationField = useAutoSaveField({ field: 'medication' });
    var form = useAutosaveForm();
    var quantity = (_c = (_b = (_a = medicationField.fieldValue) === null || _a === void 0 ? void 0 : _a.productQuantity) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
    var isNonStandardPackSizeField = useAutoSaveField({
        field: 'isNonStandardPackSize'
    });
    if (!isNonStandardPackSizeField.fieldValue) {
        return (React.createElement("div", { className: styles.readOnlyFieldContainer },
            React.createElement(MaskedTextField, { readOnly: true, label: 'Pack size', value: quantity, testId: 'text-input-pack-size' }),
            !props.readOnly && (React.createElement(EditButton, { onClick: function () {
                    var _a, _b, _c;
                    form.form.onBulkChange({
                        isNonStandardPackSize: true,
                        nonStandardPackSize: (_c = (_b = (_a = medicationField.fieldValue) === null || _a === void 0 ? void 0 : _a.productQuantity) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '0'
                    });
                    isNonStandardPackSizeField.onChange(true);
                } }))));
    }
    return (React.createElement(AutosaveTextField, { readOnly: props.readOnly, required: true, label: 'Pack size', maxLength: 9, field: 'nonStandardPackSize', hideCharacterLimit: true, filterFunction: decimalNumberInputFilter }));
};
